import * as React from "react";
import NumberUtils from "util/NumberUtils";
import { Spinner } from "components/common";
import useLicenseMetrics from "license/hooks/useLicenseMetrics";
const ActiveLicenseMetrics = () => {
  const {
    isLoading: isLoadingLicenseMetrics,
    isError: isErrorLicenseMetrics,
    data: licenseMetricsData
  } = useLicenseMetrics();
  if (isLoadingLicenseMetrics) return /* @__PURE__ */ React.createElement(Spinner, null);
  if (isErrorLicenseMetrics || !licenseMetricsData) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, licenseMetricsData.current_day !== void 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, "Cluster Usage, Today:"), /* @__PURE__ */ React.createElement("dd", null, NumberUtils.formatBytes(licenseMetricsData.current_day))), licenseMetricsData.violations_last_30_days !== void 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, "Cluster Overages, Last 30 days:"), /* @__PURE__ */ React.createElement("dd", null, licenseMetricsData.violations_last_30_days)));
};
export default ActiveLicenseMetrics;
